module.exports = __webpack_public_path__ + "img/squid-z-line-size.beec005f.svg";